<template>
  <div class="order-wrapper">
    <div class="header-text">
      <span class="fill-order">填写订单信息</span>
      <span class="order-success">订单提交成功</span>
    </div>
    <div class="bottom-bg">
      <div class="top-bg"></div>
    </div>
    <!-- header-text -->
    <div class="info-content">
      <div class="product-name">产品名称：{{plan_info.route_plan_name}}</div>
      <div class="set-time" v-if="is_visa">
        出行日期：
        <span>
          <fy-el-date
            :end_date="calendar.end_date"
            :start_date="calendar.start_date"
            v-model="route_order_add_info.travel_date"
          ></fy-el-date>
          <!-- <fy-mobile-date name="travel_date"
                          id="travel_date"
                          placeholder="请选择"
                          v-model="route_order_add_info.travel_date"
                          :start_date="calendar.start_date"
          :end_date="calendar.end_date"></fy-mobile-date>-->
        </span>
      </div>
      <div class="set-time" v-else>
        出行日期：
        <span>{{$dateUtil.df(plan_info.depart_time)}}</span>
      </div>
      <!-- 办签人数 -->
      <div class="visa-number">
        <span class="line-text">{{type_name}}数</span>
        <div class="bottom-line"></div>
        <div class="visa-type" v-for="(i, index) in effect_price_type_list">
          <span class="baseline">
            <em @click="updateTicketNum(i, false, index)" class="del-img">
              <img alt="减少" src="@/assets/images/html/j_03.png">
            </em>
            <i class="number">{{route_order_add_info['price_num_' + price_types[i]]}}</i>
            <em @click="updateTicketNum(i, true, index)" class="add-img">
              <img alt="增加" src="@/assets/images/html/add_03.png">
            </em>
          </span>
          <span class="user-type">{{plan_info['price_name_' + price_types[i]]}}</span>
          <span class="visa-price">¥{{plan_info['price_' + price_types[i]]}}</span>
        </div>
        <div
          class="child-standard"
          v-for="(price_description, index) in price_description_list"
        >{{price_description.price_name}}标准：{{price_description.price_description}}</div>
        <div class="order-remark">
          <span class="contact-text">订单备注：</span>
          <input
            class="input-width"
            placeholder="请输入"
            type="text"
            v-model.trim="route_order_contract_info.remark"
          >
        </div>
      </div>
      <!-- visa-number -->
      <!-- 优惠说明 -->
      <div class="coupon visa-number">
        <span class="line-text">优惠说明</span>
        <div class="bottom-line"></div>
        <!-- 人数优惠 -->
        <div class="coupon-information" v-if="route_order_add_info.favorable_num>1">
          <div class="coupon-left coupon-type">人数优惠</div>
          <div class="clearfix"></div>
          <div
            class="coupon-list"
            v-for="i in route_order_add_info.favorable_num - 1"
            v-if="plan_info['favorable' + i + '_num_' + price_types[0]] > 0"
          >
            <div
              class="coupon-left"
            >报名总人数超过{{plan_info['favorable' + i + '_num_' + price_types[0]]}}人</div>
            <div class="coupon-center coupon-price" v-for="(j, index) in effect_price_type_list">
              <i class="coupon-people">{{plan_info['price_name_' + price_types[j]]}} ：</i>
              ￥{{plan_info['favorable' + i + '_minus_' + price_types[j]]}}/人
            </div>
          </div>
        </div>
        <!-- 提前优惠 -->
        <div class="coupon-information" v-if="route_order_add_info.advance_num>1">
          <div class="coupon-left coupon-type coupon-advance">提前优惠</div>
          <div class="clearfix"></div>
          <div
            class="coupon-list"
            v-for="i in route_order_add_info.advance_num - 1"
            v-if="plan_info['advance' + i + '_num_' + price_types[0]] > 0"
          >
            <div class="coupon-left">报名时间在{{$dateUtil.df(plan_info['advance_time' + i])}}之前</div>
            <div class="coupon-center coupon-price" v-for="(j, index) in effect_price_type_list">
              <i class="coupon-people">{{plan_info['price_name_' + price_types[j]]}} ：</i>
              ￥{{plan_info['advance' + i + '_minus_' + price_types[j]]}}/人
            </div>
          </div>
          <div class="preference_description_line">人数优惠与提前优惠不可同时享用！</div>
        </div>
      </div>
      <div class="clearfix"></div>

      <!-- 订单优惠金额 -->
      <div class="coupon visa-number" v-if="favorable_list.length > 0">
        <span class="line-text">订单优惠金额</span>
        <em class="coupon-total-sum">¥
          <i id="favorable_amount">{{route_order_add_info.favorable_amount_input}}</i>
        </em>
        <div class="bottom-line"></div>
        <!-- 人数优惠 -->
        <div class="coupon-information" v-if="route_order_add_info.favorable_num>1">
          <div class="coupon-left coupon-type">人数优惠</div>
          <div class="clearfix"></div>
          <div class="coupon-list" v-for="(favorable_item, index) in favorable_list">
            <div class="coupon-left">
              <span>{{favorable_item.num}}</span>
              <em>{{favorable_item.name}}</em>
            </div>
            <div class="coupon-center coupon-price">￥{{favorable_item.price}}/人</div>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>

      <!-- 可选项目 -->
      <div class="visa-number" v-if="additional_list.length > 0">
        <span class="line-text">可选项目</span>
        <div class="bottom-line"></div>
        <div class="visa-type" v-for="(additional_info, index) in additional_list">
          <span class="baseline">
            <em
              @click="updateAdditionalNum(additional_info.additional_cost_id, false)"
              class="del-img"
            >
              <img alt="减少" src="@/assets/images/html/j_03.png">
            </em>
            <i
              class="number"
            >{{route_order_add_info['additional_num_' + additional_info.additional_cost_id]}}</i>
            <em
              @click="updateAdditionalNum(additional_info.additional_cost_id, true)"
              class="add-img"
            >
              <img alt="增加" src="@/assets/images/html/add_03.png">
            </em>
          </span>
          <span class="user-type">{{additional_info.additional_cost_name}}</span>
          <span class="visa-price">¥{{additional_info.price}}</span>
        </div>
      </div>

      <!-- 联系人信息 -->
      <div class="contact-info visa-number">
        <span class="line-text">联系人信息</span>
        <div class="bottom-line"></div>
        <fy-form
          :model="route_order_contract_info"
          :rules="rules"
          class="fy-form-login-pc"
          ref="form"
          v-if="!isInit"
        >
          <p class="contact-p">
            <fy-form-item :inner_width="'15%'" :prop="fields.contact_person.field_enname">
              <span class="contact-text">
                <i>*</i>联系人：
              </span>
              <fy-input
                :placeholder="fields.contact_person.field_placeholder"
                class="input-width"
                type="text"
                v-model.trim="route_order_contract_info.contact_person"
              ></fy-input>
            </fy-form-item>
          </p>
          <p class="email-p">
            <fy-form-item :inner_width="'15%'">
              <span>邮箱：</span>
              <fy-input
                class="input-width"
                placeholder="非必填"
                type="text"
                v-model.trim="route_order_contract_info.email"
              ></fy-input>
            </fy-form-item>
          </p>
          <div class="clearfix"></div>
          <p class="tel-p">
            <fy-form-item :prop="fields.contact_tel.field_enname">
              <span class="contact-text">
                <i>*</i>手机号码：
              </span>
              <fy-input
                :placeholder="fields.contact_tel.field_placeholder"
                class="input-width"
                type="text"
                v-model.trim="route_order_contract_info.contact_tel"
              ></fy-input>
            </fy-form-item>
          </p>
        </fy-form>
      </div>
      <!-- 联系人信息end -->
      <div class="clearfix"></div>

      <!-- 办签人信息 -->
      <div class="visa-info visa-number">
        <span class="line-text">{{type_name}}信息：</span>
        <div class="bottom-line"></div>
        <div v-for="(i, index) in effect_price_type_list">
          <div
            class="visa-list contacts_info_input"
            v-for="(i2, index2) in route_order_add_info['price_num_' + price_types[i]]"
          >
            <span class="visa-adult">{{plan_info['price_name_' + price_types[i]]}}</span>
            <input
              placeholder="姓 名"
              readonly="true"
              type="text"
              v-model.trim="name_list[price_types[i]][index2].name_list_name"
            >
            <a
              @click="addTravelPerson(i,index2)"
              class="visa-choose-people"
              href="javascript:void(0);"
            >{{(name_list[price_types[i]][index2].name_list_travel_id ? "编辑" : "新增") + type_name}}</a>
          </div>
        </div>
      </div>
      <!-- 办签人信息end -->
      <div class="clearfix"></div>

      <!-- 资料返还方式 -->
      <div class="contact-info visa-number">
        <span class="line-text">资料返还方式</span>
        <div class="data_return_select">
          <select v-model="route_order_return_way.pickup2_type">
            <option
              :value="option.key_value"
              v-for="option in pickup2_type_list"
            >{{option.key_name}}</option>
          </select>
        </div>
        <div class="bottom-line"></div>
        <fy-form
          :model="route_order_return_way"
          :rules="rules"
          class="fy-form-login-pc"
          ref="form_way"
          v-if="!isInit && !isInit_way"
        >
          <fy-form-item
            :label="fields.pickup2_type.field_name"
            :prop="fields.pickup2_type.field_enname"
            v-show="false"
          >
            <fy-input
              :placeholder="fields.pickup2_type.field_placeholder"
              type="text"
              v-model.trim="route_order_return_way.pickup2_type"
            ></fy-input>
          </fy-form-item>
          <p class="contact-p">
            <fy-form-item :inner_width="'15%'" :prop="fields.pickup2_customer.field_enname">
              <span class="contact-text">
                <i>*</i>
                {{fields.pickup2_customer.field_name}}：
              </span>
              <fy-input
                :placeholder="fields.pickup2_customer.field_placeholder"
                class="input-width"
                type="text"
                v-model.trim="route_order_return_way.pickup2_customer"
              ></fy-input>
            </fy-form-item>
          </p>
          <p class="contact-p">
            <fy-form-item :inner_width="'15%'" :prop="fields.pickup2_tel.field_enname">
              <span class="contact-text" style="width: 80px !important;">
                <i>*</i>
                {{fields.pickup2_tel.field_name}}：
              </span>
              <fy-input
                :placeholder="fields.pickup2_tel.field_placeholder"
                class="input-width"
                type="text"
                v-model.trim="route_order_return_way.pickup2_tel"
              ></fy-input>
            </fy-form-item>
          </p>
          <div class="clearfix"></div>
          <p class="tel-p" v-if="route_order_return_way.pickup2_type == 1">
            <fy-form-item :prop="fields.pickup2_address.field_enname">
              <span class="contact-text">
                <i>*</i>
                {{fields.pickup2_address.field_name}}：
              </span>
              <fy-input
                :placeholder="fields.pickup2_address.field_placeholder"
                class="input-width"
                type="text"
                v-model.trim="route_order_return_way.pickup2_address"
              ></fy-input>
            </fy-form-item>
          </p>
          <div class="tel-p return_store" v-show="route_order_return_way.pickup2_type == 0">
            <div>
              <em class="contact-text">领取门店：</em>
              <em>{{route_order_return_way.agent_name}}</em>
            </div>
            <div>
              <em class="contact-text">电话号码：</em>
              <em>{{route_order_return_way.tel1}}</em>
            </div>
            <div>
              <em class="contact-text">地址：</em>
              <em>{{route_order_return_way.address}}</em>
            </div>
          </div>
        </fy-form>
      </div>
      <!-- 资料返还方式end -->
      <div class="clearfix"></div>

      <!-- 订单金额明细 -->
      <div class="order-detail visa-number" v-if="!isInit2">
        <span class="line-text">订单金额明细</span>
        <div class="bottom-line"></div>
        <div class="order-detail-list">
          <div class="order-detail-1">价格种类</div>
          <div class="order-detail-2">单价</div>
          <div class="order-detail-3">订购</div>
          <div class="order-detail-4">应收金额</div>
          <div class="clearfix"></div>
          <div
            class="order-detail-item"
            v-for="(price_item, index) in getPriceList"
            v-if="getPriceList.length > 0"
          >
            <div class="order-detail-1">{{price_item.name}}</div>
            <div class="order-detail-2">{{price_item.price}}</div>
            <div class="order-detail-3">{{price_item.num}}</div>
            <div class="order-detail-4">{{price_item.total}}</div>
            <div class="clearfix"></div>
          </div>
        </div>
        <div class="clearfix"></div>
        <div class="bottom-line"></div>
        <p class="order-all">订单合计：| ￥{{route_order_add_info.payable_amount_input}}</p>
      </div>
    </div>
    <div @click="submit()" class="submit-button" style="cursor: pointer;">提交</div>

    <!-- 弹窗、模态框部分 -->
    <el-dialog :visible.sync="travelPersonDialogVisible" center title="新增办签人">
      <a-travel-person-update
        :order_add_info="route_order_add_info"
        :order_contract_info="route_order_contract_info"
        :travel_person_id="travel_person_id"
        v-if="travelPersonDialogVisible"
      ></a-travel-person-update>
    </el-dialog>
  </div>
</template>
<script>
import ATravelPersonUpdate from '@/pages/agent/travel_person/travelPersonUpdate.vue'
import { OrderAmount } from "@/api/order/orderAmount.js"
import Vue from 'vue'
var numeral = require('numeral');
let now = new Date()
let year = now.getFullYear()
let month = now.getMonth() + 1
let day = now.getDate()
let dateTime = Date.parse(now) // 当前时间时间戳
export default {
  name: 'OrderSubmit',
  componentName: 'OrderSubmit',
  components: {
    ATravelPersonUpdate
  },
  data () {
    return {
      isInit: true, //判断页面初始化时的异步加载是否完成（由于父子组件间异步传数据，有可能子组件mounted阶段时异步加载还未完成）
      isInit2: true,
      isInit_way: true,
      fields: {},
      rules: {},
      travelPersonDialogVisible: false,
      plan_info: {},
      effect_price_type_list: [],
      price_description_list: [],
      additional_list: [],
      price_types: ['a', 'b', 'c', 'd'],
      is_visa: true,
      is_route: false,
      leave_list: [],
      favorable_list: [], //优惠明细
      type_name: '办签人',
      route_order_add_info: {
        username: this.$sessionStorageUtil.get('username'),
        agent_username: this.$sessionStorageUtil.get('agent_username'),
        travel_date: dateTime,
        route_id: 0,
        route_plan_id: 0,
        source: '',
        leave_info: '', //上车点
        price_num_a: 1,
        price_num_b: 0,
        price_num_c: 0,
        price_num_d: 0,
        enable_favorable: true,
        favorable_num: 0,
        advance_num: 0,
        favorable_amount_input: 0,
        order_num: '1',
      },
      calendar: {
        start_date: new Date().getTime(),
        end_date: new Date().getTime(),
      },
      orderAmount: null,

      //填写联系人、办签人
      name_list: {},
      route_order_contract_info: {
        contact_person: '',
        contact_tel: '',
        name_list_num: 0
      },
      select_name_list_type: 'a',
      select_name_list_num: 0,
      travel_person_id: 0,
      //订单信息确定
      price_list: [], //价格明细

      //销售端 （资料返还方式）
      route_order_return_way: {
        pickup2_type: '0',
        pickup2_loc: ''
      },
      pickup2_type_list: [],
      agent_info: {},
      form_info: {
        contact_tel: '',
        source: 'oct',
        location_code: '1-1-',
        sell_mode: 0,
        favorable_amount_input: 0.00,
        price_num_a: 1,
        totalNum: 1,
        route_plan_source: 'oct',
      }
    }
  },
  created () {
    this.$pageField.init(this, 'fields', 'aOrderSubmit').then(res => {
      this.isInit = false //异步加载完成后设置为true
    })

    this.init()

    if (this.$route.query.is_open_select_sale == 1) {
      this.$domUtils.dispatch(this, 'CommonFrame', 'open.select.sale', ['order'])
    } else {
      this.getRouteOrderAdd()
      this.getRouteOrderReturnWay()
    }
    //注册事件
    this.$on('set.travel.person', this.setTravelPerson)
  },
  computed: {
    getPriceList () {
      this.price_list = this.orderAmount.itemList(true)
      return this.price_list
    }
  },
  methods: {
    init () {
      if (this.$route.query.route_id && this.$route.query.route_plan_id && this.$route.query.source) {
        if (this.isBackfill()) {
          const route_order_add_info = this.$sessionStorageUtil.get('route_order_add_info')
          if (route_order_add_info) {
            this.route_order_add_info = route_order_add_info
          }
          const name_list = this.$sessionStorageUtil.get('name_list')
          if (name_list) {
            this.name_list = name_list
          }
          const route_order_contract_info = this.$sessionStorageUtil.get('route_order_contract_info')
          if (route_order_contract_info) {
            this.route_order_contract_info = route_order_contract_info
          }
          const route_order_return_way = this.$sessionStorageUtil.get('route_order_return_way')
          if (route_order_return_way) {
            this.route_order_return_way = route_order_return_way
          }
        } else {
          this.route_order_add_info.route_id = this.$route.query.route_id
          this.route_order_add_info.route_plan_id = this.$route.query.route_plan_id
          this.route_order_add_info.source = this.$route.query.source
        }
      } else {
        if (this.$route.query.is_open_select_sale != 1) {
          this.$sessionStorageUtil.nextMsgError('参数错误')
          this.$router.go(-1)
        }
      }
    },
    getRouteOrderAdd () { // 从后台接口获取订单列表，
      const url = 'order_info/route_order_add'
      var fields = this.$myGet(url, this.route_order_add_info)
      fields.then(res => {
        this.plan_info = res.response.data.plan_info
        this.$sessionStorageUtil.set('route_order_plan_info', this.plan_info)
        this.effect_price_type_list = res.response.data.effect_price_type_list
        this.price_description_list = res.response.data.price_description_list
        // this.leave_list = res.response.data.leave_list
        this.additional_list = res.response.data.additional_list
        this.is_visa = (10 == this.plan_info.product_category)
        this.is_route = (0 == this.plan_info.product_category)
        this.type_name = this.is_visa ? '办签人' : '出行人'
        this.route_order_add_info.enable_favorable = res.response.data.enable_favorable
        this.route_order_add_info.favorable_num = res.response.data.favorable_num
        this.route_order_add_info.advance_num = res.response.data.advance_num
        // this.route_order_add_info.leave_info = this.leave_list[0].val
        this.orderAmount = new OrderAmount(this.plan_info, this.additional_list, this.effect_price_type_list, {
          favorable_num: this.route_order_add_info.favorable_num,
          favorable_advance: this.route_order_add_info.advance_num
        }, this.route_order_add_info.enable_favorable)

        let total = this.orderAmount.initTicketNums([this.route_order_add_info.price_num_a, this.route_order_add_info.price_num_b, this.route_order_add_info.price_num_c, this.route_order_add_info.price_num_d]);
        for (var i = 0; i < this.additional_list.length; i++) {
          var additional_info = this.additional_list[i]
          if (!this.route_order_add_info['additional_num_' + additional_info.additional_cost_id]) {
            Vue.set(this.route_order_add_info, 'additional_num_' + additional_info.additional_cost_id, 0)
            Vue.set(this.route_order_add_info, 'additional_name_' + additional_info.additional_cost_id, additional_info.additional_cost_name)
          } else {
            this.orderAmount.setAdditionalNum(additional_info.additional_cost_id, this.route_order_add_info['additional_num_' + additional_info.additional_cost_id])
          }
        }

        this.route_order_add_info.payable_amount_input = numeral(this.orderAmount.getTotalAmount()).format('0.00')
        this.favorable_list = this.orderAmount.favorableItemList(true)
        this.route_order_add_info.favorable_amount_input = -this.orderAmount.favorableAmount

        this.calendar.end_date = this.plan_info.return_time
        let process_cycle = Number(JSON.parse(this.plan_info.extend_info).pro_speciality.process_cycle)  //办理周期
        if (process_cycle) {
          this.calendar.start_date = this.$dateUtil.getNowDateAfterOrBeforeDay(process_cycle)  //当天加上办理周期之后
          if (!this.isBackfill()) {
            this.route_order_add_info.travel_date = this.$dateUtil.getNowDateAfterOrBeforeDay(process_cycle)  //默认出行日期为当天加上办理周期
          }
        }
        this.initNameList()
        this.isInit2 = false //异步加载完成后设置为false
      })
        .catch(err => {
          console.log('err:' + err)
        })
    },
    /**
     * 获取资料返还方式
     */
    getRouteOrderReturnWay () {
      const url = 'order_info/return_way_info'
      this.$myGet(url).then(res => {
        const rcode = res.response.data.rcode
        if (rcode == 0) {
          this.pickup2_type_list = res.response.data.pickup2_type_list
          this.agent_info = res.response.data.agent_info
          this.route_order_return_way['pickup2_loc'] = this.agent_info.agent_code
          this.route_order_return_way['agent_name'] = this.agent_info.agent_name
          this.route_order_return_way['address'] = this.agent_info.address
          this.route_order_return_way['tel1'] = this.agent_info.tel1
          this.isInit_way = false
        }
      })
        .catch(err => {
          console.log('err:' + err)
        })
    },
    /**
     * 是否回填数据
     */
    isBackfill () {
      return this.$route.query.route_plan_id == this.$sessionStorageUtil.get('dlsr_order_rpid')
    },
    /**
     * 提交
     */
    submit () {
      this.$refs.form.validate((valid, invalidFields) => {
        if (valid) {
          this.$refs.form_way.validateFields(['pickup2_type', 'pickup2_customer', 'pickup2_tel'], (message, invalidFields2) => {
            this.$sessionStorageUtil.set('route_order_return_way', this.route_order_return_way)
            if (message) {
              if (!this.setContractInfo()) {
                return;
              }
              this.$sessionStorageUtil.set('dlsr_order_rpid', this.plan_info.route_plan_id)
              this.$sessionStorageUtil.set('name_list', this.name_list)
              this.$sessionStorageUtil.set('route_order_contract_info', this.route_order_contract_info)
              this.$sessionStorageUtil.set('route_order_add_info', this.route_order_add_info)
              this.$sessionStorageUtil.set('route_order_plan_info', this.plan_info)
              this.$sessionStorageUtil.set('price_list', this.price_list) //价格明细  因为订单结果页要使用，没有remove
              this.$sessionStorageUtil.set('route_order_return_way', this.route_order_return_way)
              this.addOrder()
            } else {
              this.$msg(invalidFields2[0].message, 'error', 3000);
            }
          })
        } else {
          this.$msg(invalidFields[0].message, 'error', 3000);
        }
      })
    },
    /**
     * 添加订单
     */
    addOrder () {
      try {
        var loading = this.$loadingIndicator.eleOpen('订单正在提交...')
        if (this.route_order_add_info) {
          this.$util.copyObj2Obj(this.form_info, this.route_order_add_info)
        }
        if (this.route_order_contract_info) {
          this.$util.copyObj2Obj(this.form_info, this.route_order_contract_info)
        }
        if (this.plan_info) {
          this.form_info.product_category = this.plan_info.product_category
        }
        if (this.route_order_return_way) {
          this.$util.copyObj2Obj(this.form_info, this.route_order_return_way)
        }
        const url = 'order_info/add_order'
        var fields = this.$myPost(url, this.form_info)
        fields.then(res => {
          const rcode = res.response.data.rcode
          var msg = ""
          var is_success = false
          if (rcode == 0) {
            /*下单成功后清除sessionStorage数据 */
            this.$sessionStorageUtil.remove('route_order_add_info')
            this.$sessionStorageUtil.remove('route_order_contract_info')
            this.$sessionStorageUtil.remove('route_order_plan_info')
            this.$sessionStorageUtil.remove('name_list')
            this.$sessionStorageUtil.remove('dlsr_order_rpid')
            this.$sessionStorageUtil.remove('route_order_return_way')
            is_success = true
          } else {
            msg = res.response.data.messages[0].msg
            is_success = false
          }
          loading.close()
          this.$pushByName('aRouteOrderResult',
            {
              msg: msg,
              is_success: is_success,
              can_use_credit_amount: res.response.data.canUseCreditAmount,
              order_info_id: res.response.data.order_info_id
            })
        })
          .catch(err => {
            loading.close()
            console.error('err:' + err)
          })
      } catch (err) {
        console.error('err:' + err)
        loading.close()
      }
    },
    /**
     * 设置route_order_contract_info的值，每次提交时设置一次
     */
    setContractInfo () {
      let length = 0
      let index = 0
      let bool = true
      for (let key in this.name_list) {
        length += this.name_list[key].length
        this.name_list[key].forEach(item => {
          if (!item.name_list_travel_id) {
            this.$msg('请添加办签人！', 'info', 3000)
            bool = false
            return
          }
          this.route_order_contract_info['name_list_travel_id_n' + index] = item.name_list_travel_id
          this.route_order_contract_info['name_list_name_n' + index] = item.name_list_name
          this.route_order_contract_info['name_list_sex_n' + index] = item.name_list_sex
          this.route_order_contract_info['name_list_national_n' + index] = item.name_list_national
          this.route_order_contract_info['name_list_person_type_n' + index] = item.name_list_person_type
          this.route_order_contract_info['name_list_person_type_name_n' + index] = item.name_list_person_type_name
          this.route_order_contract_info['name_list_type_n' + index] = item.name_list_type
          index++
        })
      }
      this.route_order_contract_info.name_list_num = length
      return bool
    },
    /**
     * 新增办签人
     */
    addTravelPerson (type_key, num) {
      this.select_name_list_type = this.price_types[type_key]
      this.select_name_list_num = num
      this.travel_person_id = this.name_list[this.select_name_list_type][this.select_name_list_num].name_list_travel_id
      this.travelPersonDialogVisible = true
    },
    /**
     * 设置办签人信息
     */
    setTravelPerson (travel_person_info) {
      if (this.select_name_list_type && this.select_name_list_num != null) {
        this.name_list[this.select_name_list_type][this.select_name_list_num].name_list_travel_id = travel_person_info.sel_id
        this.name_list[this.select_name_list_type][this.select_name_list_num].name_list_name = travel_person_info.sel_name
        this.name_list[this.select_name_list_type][this.select_name_list_num].name_list_sex = travel_person_info.sel_sex
        this.name_list[this.select_name_list_type][this.select_name_list_num].name_list_national = travel_person_info.sel_nationality
        this.name_list[this.select_name_list_type][this.select_name_list_num].name_list_person_type = travel_person_info.sel_person_type
        this.name_list[this.select_name_list_type][this.select_name_list_num].name_list_person_type_name = travel_person_info.sel_person_type_name
      }
      this.travelPersonDialogVisible = false
    },
    /**
     * 初始化名单列表
     */
    initNameList () {
      if (this.effect_price_type_list && !this.isBackfill()) {
        let key_name = ''
        let key_num = ''
        let type_num = ''
        this.effect_price_type_list.forEach(item => {
          type_num = this.price_types[item]
          key_name = 'price_name_' + type_num
          key_num = 'price_num_' + type_num
          this.name_list[type_num] = []
          let num = this.route_order_add_info[key_num]
          if (num > 0) {
            for (let j = 0; j < num; j++) {
              this.name_list[type_num].push({ name_list_type: this.plan_info[key_name] })
            }
          }
        })
      }
    },
    updateTicketNum (index, increase, number) {
      let key = 'price_num_' + this.price_types[index]
      let person_type = this.plan_info[key]
      if (increase) {
        if (this.orderAmount.getTotalNum() >= this.plan_info.total_plan_num - this.plan_info.booked_num) {
          this.$msg("很抱歉，当前出行日期可预定的名额不足，请重新选择出行日期！")
        } else {
          this.route_order_add_info[key]++
          this.name_list[this.price_types[index]].push({ name_list_type: this.plan_info['price_name_' + this.price_types[index]] })
        }
      } else {
        if (this.route_order_add_info[key] > 0) {
          this.route_order_add_info[key]--
          this.name_list[this.price_types[index]].splice(this.name_list[this.price_types[index]].length - 1, 1)
        }
      }
      let total = this.orderAmount.setTicketNum(index, this.route_order_add_info[key])
      this.route_order_add_info.payable_amount_input = numeral(total).format('0.00')
      this.favorable_list = this.orderAmount.favorableItemList(true)
      this.route_order_add_info.favorable_amount_input = -this.orderAmount.favorableAmount
      this.route_order_add_info.order_num = this.orderAmount.getTotalNum().toString()
    },
    updateAdditionalNum (id, increase) {
      let key = 'additional_num_' + id
      if (increase) {
        this.route_order_add_info[key]++
      } else {
        if (this.route_order_add_info[key] > 0) {
          this.route_order_add_info[key]--
        }
      }
      let total = this.orderAmount.setAdditionalNum(id, this.route_order_add_info[key])
      this.route_order_add_info.payable_amount_input = numeral(total).format('0.00');
      this.favorable_list = this.orderAmount.favorableItemList(true)
    },
  }
}

</script>
<style scope>
@import '../../assets/css/pages/customer/customer.css';
</style>



// WEBPACK FOOTER //
// src/pages/agent/aOrderSubmit.vue